import valueCoMarket from "../assets/values-co-market-place.webp";
import valueCoDashboard from "../assets/values-co-admin.webp";
import derivedArtMarket from "../assets/delivered-art-user.webp";
import derivedArtAdminBoard from "../assets/derived-art-admin-board.webp";


export const ProjectList = [
  {
    "id": 1,
    "slug": "value-co-market",
    'type': 'Express JS',
    name: "Values Co Market",
    image: valueCoMarket,
    skills: "NodeJS, JavaScript, ExpressJS, TypeScript, Mysql, ObjectionJS",
    description: "ValuesCo is the social token platform that gives a damn. Our platform enables community leaders and members to easily co-create value, while accomplishing impact missions."
  },
  {
    "id": 2,
    name: "Values Co Dashboard",
    'type': 'Express JS',
    slug: "values-co-dashboard",
    image: valueCoDashboard,
    skills: "NodeJS, JavaScript, ExpressJS, TypeScript, Mysql, ObjectionJS",
    description: "ValuesCo is the social token platform that gives a damn. Our platform enables community leaders and members to easily co-create value, while accomplishing impact missions."
  },
  {
    "id": 3,
    name: "Derived Art Market",
    slug: "derived-art-market",
    'type': 'Nest JS',
    image: derivedArtMarket,
    skills: "NodeJS, JavaScript, MongoDB, NestJS, TypeScript, Mongoose",
    description: "NFT art of remixed key historical moments co-created by the world's leading artists and cultural institutions."
  },
  {
    "id": 4,
    name: "Derived Art Admin Board",
    slug: "derived-art-admin-board",
    'type': 'Nest JS',
    image: derivedArtAdminBoard,
    skills: "NodeJS, JavaScript, MongoDB, NestJS, TypeScript, Mongoose",
    description: "NFT art of remixed key historical moments co-created by the world's leading artists and cultural institutions."
  }
];